import { render, staticRenderFns } from "./OrderChooseDiagnostic.vue?vue&type=template&id=f442ebec&scoped=true&"
import script from "./OrderChooseDiagnostic.vue?vue&type=script&lang=js&"
export * from "./OrderChooseDiagnostic.vue?vue&type=script&lang=js&"
import style0 from "./OrderChooseDiagnostic.vue?vue&type=style&index=0&id=f442ebec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f442ebec",
  null
  
)

export default component.exports